import { gql } from "@apollo/client";

export const GET_MEMBERS = gql`
  query ZoneMembers {
    zoneMembers {
        NAME
        MOBILE1
        MOBILE2
        ADDRESS
        NAGAR
        AREA
        CITY
        PINCODE
        role
    }
  }
`;

export const GET_MEMBER_DETAILS = gql`
  query ZoneMember($mobile: String!) {
    zoneMember(mobile: $mobile) {
        NAME
        MOBILE1
        PINCODE
        NAGAR
        CITY
        AREA
      
    }
  }
`;

// Query to check if a mobile number already exists
export const CHECK_DUPLICATE_MOBILE = gql`
  query CheckDuplicate($field: String!, $value: String!) {
    checkDuplicate(field: $field, value: $value)
  }
`;

// You can add other queries here as needed
export const GET_USER_BY_MOBILE = gql`
  query GetUserByMobile($mobile: String!) {
    getUserByMobile(mobile: $mobile) {
      id
      mobile
      name
      email
    }
  }
`;
